import { Routes, Route, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Admin from './Admin';
import ShareView from './ShareView';
import Login from './Login';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'changeme123';
const AUTH_KEY = 'purchase_app_authed';

export default function App() {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem(AUTH_KEY) === 'true');

  const login = (pw) => {
    if (pw === ADMIN_PASSWORD) {
      sessionStorage.setItem(AUTH_KEY, 'true');
      setAuthed(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    sessionStorage.removeItem(AUTH_KEY);
    setAuthed(false);
  };

  return (
    <Routes>
      <Route path="/share/:shareId" element={<ShareView />} />
      <Route path="/login" element={
        authed ? <Navigate to="/" replace /> : <Login onLogin={login} />
      } />
      <Route path="/*" element={
        authed ? <Admin onLogout={logout} /> : <Navigate to="/login" replace />
      } />
    </Routes>
  );
}
